import { minutesToHoursAndMinutes } from '../../../../utils/minutesToHoursAndMinutes';
import { accommodationTypes } from '../../../../constants/accommodations/accommodationTypes';

/**
 * Builds table data for exam timings, including standard and accommodation times.
 * @param sections - Array of sections with their titles and times in minutes.
 * @returns Array of table data objects with formatted times.
 */
export function buildTableData(sections: { sectionTitle: string; standardDuration: number }[]) {
  return sections.map((section) => {
    const isBreak = section.sectionTitle.toLowerCase() === 'break';
    return {
      sectionTitle: section.sectionTitle,
      standardTime: minutesToHoursAndMinutes(section.standardDuration),
      ...Object.fromEntries(
        accommodationTypes.map((a: { title: string; multiplier: number }) => [
          a.title,
          minutesToHoursAndMinutes(
            isBreak ? section.standardDuration : Math.ceil(section.standardDuration * a.multiplier)
          ),
        ])
      ),
    };
  });
}

/*
 * Type for a row in the exam timings table, which includes the section title, standard time, and accommodation times.
 */
export type TableRow = ReturnType<typeof buildTableData>[number] & { _isSeparator?: boolean };
